module.exports = __webpack_public_path__ + "static/callout-a4c6fc9eb509ad9e8d17ee599937c5b1.jpg";